/**
 * It takes a file name as a parameter and returns true if the file is a video file and false if it's
 * not.
 * @param fileName - The name of the file you want to check.
 * @returns A boolean value.
 */
export const getExtensionVideoFile = async fileName => {
  const videoExtensions = require('video-extensions');
  let isVideoFileExt = fileName.split('.').pop();
  let found = videoExtensions.find(element => element === isVideoFileExt);
  return found ? true : false;
};
